import { initVideoCategoryList } from './list.js';

/**
 * Entry point for Video Category module
 */
export function initVideoCategories() {
	initVideoCategoryList();
}
